<template>
    <service-navigation-header
        :config="config"
        :breadcrumb-items="breadcrumbItems"
    >
      <div slot="account" >
        <or-profile-popover
            :auth-ui-url="AUTH_UI_URL"
        />
      </div>
    </service-navigation-header>
</template>

<script>
import get from 'lodash/get'
import { mapState } from 'vuex'
import config from '@/config'
import { ServiceNavigationHeader } from '@onereach/service-navigation/dist/vue2'
import { OrProfilePopover } from '@onereach/ui'

export default {
  components: {
    ServiceNavigationHeader,
    OrProfilePopover
  },

  computed: {
    ...mapState('knowledgebase', ['knowledgeBases']),
    ...mapState('knowledgebase/customModels', ['customModels']),

    AUTH_UI_URL () {
      return config.AUTH_UI_URL
    },

    allModels () {
      return [...this.knowledgeBases, ...this.customModels]
    },

    modelName () {
      return get(this.allModels.find(m => m.id === this.$route.params.id), 'name', 'Model')
    },

    breadcrumbItems () {
      return this.$route.name === 'model'
        ? [
            { label: 'My knowledge models', to: '/' },
            { label: this.modelName, to: `/model/${this.$route.params.id}` }
          ]
        : []
    }
  },

  data () {
    return {
      config
    }
  }
}
</script>
